import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AssignmentTemplates: 'Assignment templates',
  NoAssignmentTemplates: 'There are no assignment templates',
  Add: 'Add',
  AddAssignmentTemplate: 'Add assignment template',
  AddTaskTemplate: 'Add task template',
  TaskTemplate: 'Task template',
  TaskPeriodicity: 'Task periodicity',
  TaskTemplates: 'Task templates',
  NoDefault: 'No default',
  SelectTaskTemplate: 'Select task template',
  DefaultTaskPeriodicity: 'Default task periodicity',
  ChoosePeriodicityWhenCreatingAssignment: 'Choose peridocity when creating assignment',
  Name: 'Name',
  AppliesToPerson: 'Applies to person',
  AppliesToSoleProprietor: 'Applies to sole proprietor',
  AppliesToCompany: 'Applies to company',
  Cancel: 'Cancel',
  DeleteAssignmentTemplate: 'Delete assignment template?',
  DeleteAssignmentTemplateConfirmationMsg:
    'Are you sure you want to delete this assignment template?',
  Code: 'Code',
  DefaultAssignment: 'Default assignment',
  ConfigureAllowResources: 'Configure allowed resources',
  ConfigureAllowResourcesForDefaultAssignment: 'Configure allowed resources for default assignment',
  Save: 'Save',
  Close: 'Close',
  Search: 'Search',
  Allowed: 'Allowed',
  NoItems: 'No items',
  OnlyFiltered: 'Only filtered',
  InForfait: 'In forfait',
  InForfaitSetForAssignmentTemplateClickToReset:
    'In forfait overriden for this assignment template, click to reset to default value',
  ResetInForfaitForAll: 'Reset in forfait for all items',
  RecalculateInForfaitOnRegistrations: 'Recalculate in forfait on registrations',
  AllowMultiplePerRelation: 'Allow multiple per relation',
  InForfaitInheritanceInfo: 'InForfaitInheritanceInfo',
  MergeWith: 'Merge with',
  DoNotMerge: 'Do not merge',
  PropagateMergingMsg: 'Do you want to propagate this merging to all active assignments?',
  InvoiceSchedule: 'Invoice schedule',
  NoInvoiceSchedule: 'No invoice schedule',
  OwnCompany: 'Own company',
  EditInvoiceSchedule: 'Edit invoice schedule',
  Amount: 'Amount',
  AmountMustBeGreaterThanZero: 'Amount must be greater than 0',
  LedgerAccount: 'Ledger account',
  CostLedgerAccount: 'Cost ledger account',
  UseRelationSetting: 'Use relation setting',
});

export default messages;
